'use strict';

exports.__esModule = true;
exports.Editable = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _class2, _temp2; // import { graphql } from 'react-apollo';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../../..');

var _2 = _interopRequireDefault(_);

var _Editable = require('apollo-cms/lib/DataView/Object/Editable');

var _Editable2 = _interopRequireDefault(_Editable);

var _ListView = require('../../Connectors/Connector/ListView');

var _context2 = require('../../../../context');

var _Query = require('../../Connectors/Query');

var _Query2 = _interopRequireDefault(_Query);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _graphql = require('graphql');

var _pathToRegexp = require('path-to-regexp');

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

var _EditableView = require('./EditableView');

var _EditableView2 = _interopRequireDefault(_EditableView);

var _DefaultView = require('./DefaultView');

var _DefaultView2 = _interopRequireDefault(_DefaultView);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Editable = exports.Editable = (_temp = _class = function (_ApolloEditableObject) {
  _inherits(Editable, _ApolloEditableObject);

  function Editable(props) {
    _classCallCheck(this, Editable);

    var _this = _possibleConstructorReturn(this, _ApolloEditableObject.call(this, props));

    _this.bindGetButtons = function () {
      return function () {
        return _this.getButtons();
      };
    };

    _this.mutate = _this.mutate.bind(_this);
    return _this;
  } // componentDidUpdate(prevProps, prevState) {
  //   const keys = Object.keys(this.props);
  //   keys.map(key => {
  //     const value = this.props[key];
  //     const prevValue = prevProps[key];
  //     if (value !== undefined && prevValue !== undefined && value !== prevValue) {
  //       console.log("Editable componentDidUpdate value !== prevValue / ", key, value, prevValue);
  //     }
  //   });
  //   super.componentDidUpdate && super.componentDidUpdate(prevProps, prevState);
  // }


  Editable.prototype.mutate = function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee(props) {
      var _props, children, getQueryNameFromQuery, extendQuery, queries, _ref2, objectId, mutation, error, extendedQuery;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              /**
                  Prepare Mutation
                   */
              _props = this.props, children = _props.query_components, getQueryNameFromQuery = _props.getQueryNameFromQuery, extendQuery = _props.extendQuery;
              queries = {};
              _ref2 = this.getObject() || {}, objectId = _ref2.id;
              children && children.length && children.filter(function (n) {
                return n;
              }).map(function (n) {
                var type = n.type,
                    props = n.props;

                if (type === _Query2.default) {
                  var _ref3 = props && props.props || {},
                      query = _ref3.query;

                  if (query) {
                    var queryName = getQueryNameFromQuery(query);

                    if (queryName) {
                      queries[queryName] = query;
                    }
                  }
                }
              });
              mutation = objectId ? queries.update : queries.create;

              if (mutation) {
                _context.next = 8;
                break;
              }

              error = new Error("Can not get mutation");
              return _context.abrupt('return', this.addError(error));

            case 8:
              /**
              Eof Prepare Mutation
               */
              try {
                extendedQuery = extendQuery(mutation); // console.log("mutation", mutation);
                // console.log("mutation extendQuery", extendedQuery);
                // console.log("props", props);

                mutation = (0, _graphqlTag2.default)(extendedQuery);
              } catch (error) {
                console.error(error);
              }

              return _context.abrupt('return', _ApolloEditableObject.prototype.mutate.call(this, _extends({}, props, {
                mutation: mutation // mutation: extendedQuery(mutation),

              })));

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mutate(_x) {
      return _ref.apply(this, arguments);
    }

    return mutate;
  }();

  Editable.prototype.renderEditableView = function renderEditableView() {
    var children = this.props.children; // return children ? children.filter(n => n && n.type !== DefaultView) : children;

    return children;
  };

  Editable.prototype.renderDefaultView = function renderDefaultView() {
    var children = this.props.children; // return children ? children.filter(n => n && n.type !== EditableView) : children;

    return children;
  }; // getCacheKey = () => {
  //   const {
  //     cacheKey,
  //   } = this.props;
  // }


  Editable.prototype.renderHeader = function renderHeader() {
    var show_header = this.props.show_header;
    return show_header ? _ApolloEditableObject.prototype.renderHeader.call(this) : null;
  };

  Editable.prototype.render = function render() {
    var _this2 = this;

    return _react2.default.createElement(_context2.EditableObjectContext.Provider, {
      value: _extends({
        updateObject: function updateObject(data) {
          return _this2.updateObject(data);
        },
        getEditor: function getEditor(props) {
          return _this2.getEditor(props);
        },
        inEditMode: this.isInEditMode(),
        canEdit: this.canEdit(),
        getObjectWithMutations: function getObjectWithMutations() {
          return _this2.getObjectWithMutations();
        },
        getObject: function getObject() {
          return _this2.getObject();
        },
        // getCacheKey: this.getCacheKey,
        getButtons: this.bindGetButtons(),
        mutate: this.mutate
      }, this.props)
    }, _react2.default.createElement(_ListView.ObjectContext.Provider, {
      value: {
        object: this.getObjectWithMutations()
      }
    }, _ApolloEditableObject.prototype.render.call(this)));
  };

  return Editable;
}(_Editable2.default), _class.propTypes = _extends({}, _Editable2.default.propTypes, {
  show_header: _propTypes2.default.bool.isRequired,
  extendQuery: _propTypes2.default.func.isRequired,
  getQueryNameFromQuery: _propTypes2.default.func.isRequired,
  query_components: _propTypes2.default.array.isRequired
}), _class.defaultProps = _extends({}, _Editable2.default.defaultProps, {
  show_header: true
}), _temp);
var EditableObject = (_temp2 = _class2 = function (_EditorComponent) {
  _inherits(EditableObject, _EditorComponent);

  function EditableObject(props) {
    _classCallCheck(this, EditableObject);

    var _this3 = _possibleConstructorReturn(this, _EditorComponent.call(this, props));

    _this3.onBeforeDrop = function () {};

    _this3.extendQueryBind = function (Query) {
      return _this3.extendQuery(Query);
    };

    _this3.onCreateObject = _this3.onCreateObject.bind(_this3);
    return _this3;
  }

  EditableObject.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelEditableObject
    }, 'EditableObject'));
  };

  EditableObject.prototype.getEditableClass = function getEditableClass() {
    return Editable;
  };

  EditableObject.prototype.renderChildren = function renderChildren() {
    var _this4 = this; // const {
    //   inEditMode,
    // } = this.getEditorContext();


    var children = _EditorComponent.prototype.renderChildren.call(this);

    var _getComponentProps = this.getComponentProps(this),
        on_create_redirect_url = _getComponentProps.on_create_redirect_url,
        props = _getComponentProps.props,
        data = _getComponentProps.data,
        components = _getComponentProps.components,
        style = _getComponentProps.style,
        cache_key = _getComponentProps.cache_key,
        cache_key_prefix = _getComponentProps.cache_key_prefix,
        new_object_cache_key = _getComponentProps.new_object_cache_key,
        object = _getComponentProps.object,
        other = _objectWithoutProperties(_getComponentProps, ['on_create_redirect_url', 'props', 'data', 'components', 'style', 'cache_key', 'cache_key_prefix', 'new_object_cache_key', 'object']);

    var Editable = this.getEditableClass();
    return _react2.default.createElement(_ListView.ObjectContext.Consumer, null, function (context) {
      var object = context.object,
          loading = context.loading;
      /**
      Если объекта нет и еще выполняется загрузка,
      прерываем рендерер.
      Иначе объект будет инициализирован как новый, то есть в режиме редактирования со свойством _dirty
       */

      if (!object && loading) {
        return null;
      }

      var _ref4 = object || {},
          objectId = _ref4.id;

      var cacheKey = cache_key ? cache_key : new_object_cache_key && !objectId ? new_object_cache_key : undefined;
      var cacheKeyPrefix = cache_key_prefix;
      return _react2.default.createElement(Editable // data={{
      //   object: object || {},
      // }}
      , _extends({
        object: object || {},
        extendQuery: _this4.extendQueryBind // extendQuery={(query) => this.extendQuery(query)}
        ,
        getQueryNameFromQuery: _this4.getQueryNameFromQuery,
        query_components: children // mutation={gql(extendedQuery)}
        // mutate__={async props => {
        //   try {
        //     let queries = {
        //     }
        //     children && children.length && children.filter(n => n).map(n => {
        //       const {
        //         type,
        //         props,
        //       } = n;
        //       if (type === Query) {
        //         const {
        //           query,
        //         } = props && props.props || {};
        //         if (query) {
        //           const queryName = this.getQueryNameFromQuery(query);
        //           if (queryName) {
        //             queries[queryName] = query;
        //           }
        //         }
        //       }
        //     });
        //     let mutation = objectId ? queries.update : queries.create;
        //     if (!mutation) {
        //       // this.addError("Can not get mutation");
        //       const error = new Error("Can not get mutation");
        //       this.addError(error);
        //       return error;
        //     }
        //     const extendedQuery = this.extendQuery(mutation);
        //     return await this.mutate({
        //       mutation: gql(extendedQuery),
        //       ...props,
        //     })
        //       .catch(error => {
        //         console.error(error);
        //         return error;
        //       })
        //       ;
        //   }
        //   catch (error) {
        //     console.error(error);
        //     return error;
        //   }
        // }}
        // onSave={this.prepareOnSave(object)}
        // onSave={this.onCreateObjectBind}
        ,
        onSave: !objectId ? _this4.onCreateObject : null,
        cacheKey: cacheKey,
        cacheKeyPrefix: cacheKeyPrefix
      }, _this4.prepareObject(context), other), children);
    });
  };

  EditableObject.prototype.prepareObject = function prepareObject(context) {
    return {
      _dirty: this.getDirty(context)
    };
  };

  EditableObject.prototype.getDirty = function getDirty(context) {
    var object = context.object,
        _dirty = context._dirty; // return _dirty ? _dirty : !object ? {} : undefined;

    return _dirty;
  }; // prepareOnSave = (object) => {
  //   const {
  //     id: objectId,
  //   } = object || {};
  //   if (!objectId) {
  //     return result => this.onCreateObject(result)
  //   }
  //   else {
  //     return result => this.onUpdateObject(result)
  //   }
  // }
  // onCreateObjectBind = () => this.onCreateObject();


  EditableObject.prototype.onCreateObject = function onCreateObject(result) {
    var _getComponentProps2 = this.getComponentProps(this),
        on_create_redirect_url = _getComponentProps2.on_create_redirect_url; // console.log("onCreateObject on_create_redirect_url", on_create_redirect_url);


    if (on_create_redirect_url) {
      var _ref5 = result.data || {},
          response = _ref5.response;

      var _ref6 = response || {},
          object = _ref6.data; // console.log("onCreateObject object", { ...object });
      // console.log("onCreateObject result", { ...result });


      if (object) {
        var toPath = _pathToRegexp2.default.compile(on_create_redirect_url);

        try {
          var url = toPath(object, {
            noValidate: true
          });

          if (url) {
            var history = this.context.router.history;
            history.push(decodeURIComponent(url));
          }
        } catch (error) {
          console.error(error);
        }
      }
    }

    return;
  }; // onUpdateObject(result) {
  //   return result;
  // }

  /**
   * Расширяем запрос
   */


  EditableObject.prototype.extendQuery = function extendQuery(Query) {
    var _this5 = this;

    var schema = this.context.schema; // console.log("Viewer EditableObject schema", schema);

    if (Query && schema) {
      /**
       * Проходим запрос на предмет директив в фрагментах
       */
      var parsedQuery = (0, _graphql.parse)(Query);

      if (parsedQuery && schema) {
        var types = schema.types;
        var definitions = parsedQuery.definitions;

        if (definitions && definitions.length) {
          definitions.reduceRight(function (current, definition) {
            var kind = definition.kind,
                directives = definition.directives,
                _definition$selection = definition.selectionSet.loc,
                start = _definition$selection.start,
                end = _definition$selection.end,
                body = _definition$selection.source.body,
                typeCondition = definition.typeCondition;

            if (kind === "FragmentDefinition" && typeCondition) {
              var needAutoloadFields = directives && directives.find(function (n) {
                return n && n.name && n.name.value === "prismaCmsFragmentAllFields";
              }) ? true : false;

              if (needAutoloadFields) {
                var _kind = typeCondition.kind,
                    type = typeCondition.name.value;
                /**
                 * Если указана автоподгрузка типов и получен тип, то получаем все скалярные поля для этого типа
                 */

                var fragmentSource = body.slice(start, end);

                if (type) {
                  var field = types.find(function (n) {
                    var kind = n.kind,
                        name = n.name;
                    return kind === "OBJECT" && name === type;
                  });

                  if (field) {
                    var fields = field.fields;
                    fields = fields.filter(function (n) {
                      return n && n.name && _this5.isScalar(n) ? true : false;
                    });
                    /**
                     * Если были получены скалярные поля,
                     * добавляем их в запрос
                     */

                    if (fields.length) {
                      var fieldsList = "\n" + fields.map(function (_ref7) {
                        var name = _ref7.name;
                        return name;
                      }).join("\n") + "\n";
                      var position = end - 1;
                      Query = [Query.slice(0, position), fieldsList, Query.slice(position)].join('');
                    }
                  }
                }
              }
            }

            return current;
          }, []);
        }
      }
    }

    return Query;
  };

  EditableObject.prototype.isScalar = function isScalar(field) {
    var _field$type = field.type,
        kind = _field$type.kind,
        ofType = _field$type.ofType;

    if (kind === "SCALAR") {
      return true;
    } else if (kind === "ENUM") {
      return true;
    } else if ((kind === "NON_NULL" || kind === "LIST") && ofType) {
      return this.isScalar({
        type: ofType
      });
    } else {
      return false;
    }
  };

  EditableObject.prototype.getQueryNameFromQuery = function getQueryNameFromQuery(query) {
    try {
      var parsedSchema = (0, _graphql.parse)(query);

      if (parsedSchema) {
        var definitions = parsedSchema.definitions;

        if (definitions) {
          var OperationDefinition = definitions.find(function (n) {
            return n.kind === "OperationDefinition";
          });

          if (OperationDefinition) {
            var _ref8 = OperationDefinition.name || {},
                value = _ref8.value;

            return value;
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return EditableObject;
}(_2.default), _class2.defaultProps = _extends({}, _2.default.defaultProps, {
  style: _extends({}, _2.default.defaultProps.style, {
    flexBasis: "100%"
  }),

  /**
   * УРЛ, куда редиректить при создании нового объекта
   */
  on_create_redirect_url: undefined,
  cache_key: undefined,
  cache_key_prefix: undefined,
  new_object_cache_key: undefined,
  show_header: true,
  hide_wrapper_in_default_mode: true
}), _class2.Name = "EditableObject", _class2.help_url = "https://front-editor.prisma-cms.com/topics/editableobject.html", _temp2);
exports.default = EditableObject;